import React from "react";
import { createBrowserHistory } from "history";
import { Switch, Route } from "react-router";
import FavouritesPage from "./pages/FavouritesPage";

export const browserHistory = createBrowserHistory();

const FavouritesRouter: React.FC = () => {
  return (
    <Switch>
      <Route path="/favourites" component={FavouritesPage} />
    </Switch>
  );
};

export default FavouritesRouter;
